import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'coupon',
    serviceName: 'auth',
    query: gql`
      query coupon($ids: [String], $for_admin: Int) {
        coupon(ids: $ids, for_admin: $for_admin) {
          data {
            title
            amount
            end_date
            start_date
            description
            shop {
              id
            }
            category {
              id
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateCoupon',
    serviceName: 'unitadmin',
    query: gql`
      mutation updateCoupon(
        $ids: [String]!
        $type: String
        $title: String!
        $amount: Int!
        $shop_id: String!
        $end_date: String
        $start_date: String
        $description: String
        $is_active: Int
      ) {
        updateCoupon(
          ids: $ids
          type: $type
          title: $title
          amount: $amount
          shop_id: $shop_id
          end_date: $end_date
          start_date: $start_date
          description: $description
          is_active: $is_active
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
